<template lang="pug">
  .notice-block
    .notice-content
      font-awesome-icon.icon(icon="info-circle")
      span.text In case you have any concerns with the vLEI Credential(s), please address these to
        b.email info@gleif.org
    .notice-action
</template>
<script>

export default {
  data () {
    return {
      data: [],
    }
  },
}
</script>
<style lang="stylus" scoped>
@import "../../../assets/styles/variables.styl"

.notice-block
  display flex
  align-items center
  justify-content space-between
  padding 15px 15px
  background #f0fdfa
  border-radius 5px
  margin 20px 0
  line-height 25px

  @media screen and (max-width: $laptop)
    margin 0px 20px

  @media screen and (max-width: $tablet)
    margin 0px 0px

.email
  margin-left 4px
.icon
  margin-right 10px
</style>



// WEBPACK FOOTER //
// src/components/record-details/credentials/CredentialNotice.vue